import { ApiCurrency } from 'data/Currencies/types'
import React from 'react'
import Rows from 'scenes/Cashflow/Rows'
import { ModalContainer } from 'scenes/Cashflow/styles'

type Props = {
  currencies: ApiCurrency[]
  onItemClick: (currency: string) => void
}
const FiatOptions = ({ currencies, onItemClick }: Props) => {
  const availableCurrencies = currencies
    .filter((c) => c.type.name === 'FIAT')
    .sort((a, b) => (a.name < b.name ? -1 : 1))

  const rows = availableCurrencies.map((currencyItem) => ({
    onClick: () => onItemClick(currencyItem.symbol),
    symbol: currencyItem.symbol,
    title: currencyItem.name,
    type: 'currency'
  }))

  return (
    <ModalContainer>
      <Rows rows={rows} />
    </ModalContainer>
  )
}

export default FiatOptions
